const getInitialState = () => ({
  session_uid: null,
  session_max_hands: -1,
  session_hands_uids: [],
  session_finished_hands_uids: [],
  session_finished: false,
  session_settings: null,
  session_error: false,
})

const getters = {
  session_error: state => state.session_error,
  session_uid: state => state.session_uid,

  session_max_hands: state => state.session_max_hands,
  session_finished: state => state.session_finished,
  session_count: state => ({
    current_hands: state.session_finished_hands_uids.length,
    max_hands: state.session_max_hands,
  }),
  session_remaining_hands: state => {
    const res =
      state.session_max_hands -
      (state.session_finished_hands_uids.length + state.session_hands_uids.length)
    return res
  },
}

const actions = {
  session_start({ state, dispatch, rootGetters }, sessionId) {
    const maxHands = rootGetters[`tra/alpha/fh_trainer_session`] || Infinity
    if (maxHands && (!state.session_uid || state.session_finished)) {
      dispatch('session_reset')
      dispatch('stats_session_reset')
      state.session_max_hands = maxHands
      state.session_uid = sessionId
      state.session_settings = JSON.parse(JSON.stringify(rootGetters[`tra/alpha/query_trainer`]))
    }
  },
  session_register_hand({ state }, { hand_uid }) {
    if (!state.session_uid) return
    state.session_hands_uids = [...state.session_hands_uids, hand_uid]
  },
  session_unregister_hand({ state }, { hand_uid }) {
    if (!state.session_uid) return
    state.session_hands_uids = state.session_hands_uids.filter(i => i !== hand_uid)
  },
  session_add_hand({ state, commit, dispatch, rootGetters }, { hand_uid }) {
    if (!state.session_uid || state.session_finished) return
    state.session_finished_hands_uids = [...state.session_finished_hands_uids, hand_uid]
    dispatch('session_unregister_hand', { hand_uid })

    const session = {
      uid: state.session_uid,
      session_state: { ...state },
      stats_session: rootGetters.stats_session,
      created_at: Date.now(),
    }
    dispatch('history_update_session', { session })

    dispatch('session_finish')
  },
  session_finish({ state, commit, dispatch, rootGetters }) {
    const sessionFinished = state.session_max_hands === state.session_finished_hands_uids.length
    if (sessionFinished) {
      state.session_finished = true

      const session = {
        uid: state.session_uid,
        session_state: { ...state },
        stats_session: rootGetters.stats_session,
        created_at: Date.now(),
      }
      dispatch('history_update_session', { session })
      dispatch(`stats_show_session_result`, session)
      // debugger
      dispatch(`hands_lock_namespaces`, {
        namespaces: ['tra/alpha', 'tra/beta', 'tra/gamma', 'tra/delta'],
      })
    }
  },
  session_end({ commit }) {
    commit(`session_reset`)
  },
  // session_restore({ state, commit, dispatch }, { session }) {
  //   commit('session_reset', session.session_state)
  //   dispatch('stats_session_restore', { stats_session: session.stats_session })
  // },
  session_reset({ commit }) {
    commit('session_reset')
  },
}
const mutations = {
  session_reset(state, initialState = getInitialState()) {
    Object.assign(state, initialState)
  },
  session_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations,
}
